export const environment = {
  production: false,

  pusherKey: 'a10e229a150dfd4ebfce',
  openaiKey: "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",  // Para ChatGPT
  iconsUrl: "assets/stylesicon.css",

  // Backend Dev (rama: dev) — App Engine service `api-stage` en GCP
  baseUrl: "https://api-stage-dot-f2rt-avi.ue.r.appspot.com/api/",

  googleMaps: {
    apiKey: 'AIzaSyAeti2mPpKGTfdO2Nb6H9-j2Mi9KCgEHd8',
    options: {
      region: 'CO',
      language: 'es',
      libraries: ['places'],
    }
  },
  openWeatherMap: {
    apiKey: 'e1748bb9d7cc7c91d5a9623d00bcbfef',
    baseUrl: 'https://tile.openweathermap.org/map'
  },
  openAip: {
    apiKey: '0f72033c6fd1f69ad60e254b4cb36afc',
    tilesUrl: 'https://api.tiles.openaip.net/api/data',
    coreApiUrl: 'https://api.core.openaip.net/api',
    subdomains: ['a', 'b', 'c']
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoibmlsYW9uMDMzMCIsImEiOiJjbWtiamozdW0wNDZ2M2Zwb2NpOHcyd3JxIn0.WyrSWd72KEuReRUQpiENBg'
  }
};
